var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import api from './api';
import { LOCATIONS_URL, COUNTRIES_URL } from './constants';
import { useQuery } from 'react-query';
import { useStore } from 'hooks/useStore';
import { getISO2CountryCode } from '../utils/functions';
export function useGetLocations(props) {
    const selectedCountry = useStore((s) => s.country);
    return useQuery(['locations', selectedCountry], () => __awaiter(this, void 0, void 0, function* () {
        const result = yield api.get(LOCATIONS_URL);
        return result.data;
    }), Object.assign({ enabled: !!selectedCountry }, props === null || props === void 0 ? void 0 : props.options));
}
export function useGetCountries() {
    return useQuery(['countries'], () => __awaiter(this, void 0, void 0, function* () {
        const result = yield api.get(COUNTRIES_URL);
        return result.data;
    }), {
        select: (countries) => {
            return countries.map((countryData) => {
                return {
                    key: countryData.code,
                    text: countryData.name,
                    value: countryData.code,
                    flag: getISO2CountryCode(countryData.code).toLowerCase(),
                };
            });
        },
    });
}
